<template>
  <SideMenu
    ref="sideMenu"
    :heading="title"
    :side="'right'"
    @on-side-menu-close="$emit('onHelpMenuClose')"
  >
    <div class="h-full p-24">
      <div v-html="content" />
    </div>
  </SideMenu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SideMenu, { type SideMenuInterface } from '~/components/navigation/SideMenu.vue';

export default defineComponent({
  components: {
    SideMenu,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.toggleSideMenu();
  },
  methods: {
    closeSideMenu() {
      const sideMenu = this.$refs.sideMenu as SideMenuInterface;
      sideMenu.closeOverlay();
    },
    toggleSideMenu() {
      const sideMenu = this.$refs.sideMenu as SideMenuInterface;
      sideMenu.openOverlay();
    },
  },
});
</script>
